import { struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Request = struct({
	password: iotsUtils.NotEmptyString,
});
